import { ChangeDetectionStrategy, Component, Input, OnChanges, signal, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WorldService } from 'src/app/services/world.service';
import { Npc } from '../../../dto';
import { AuthService } from '../../../services/auth.service';
import { UIStateService } from '../../../services/ui-state.service';
import { AuthenticatedPageComponent } from '../../base.component';
import { MainpageComponent } from '../../mainpage/mainpage.component';
import { InteractorComponent } from '../../ui/interactor/interactor.component';


@Component({
    selector: 'app-npc',
    templateUrl: './npc.component.html',
    styleUrls: ['./npc.component.scss'],
    host: { class: 'full-width' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NpcComponent extends AuthenticatedPageComponent implements OnChanges {

    public static route = 'npc';
    private static inputPropertyName = 'npcDetails';
    // Set inside the retrieveNpcOptions() subscribe callback below - that call is kicked off by
    // an @Input() change (ngOnChanges), but resolves after that change's own OnPush check already
    // ran, so this needs to be a signal for the interactor to actually become visible.
    protected activated = signal(false);
    @Input(NpcComponent.inputPropertyName) npcDetails: Npc;
    @Input() injectedClass: string;

    @ViewChild('interactor') interactor: InteractorComponent;

    constructor(private worldService: WorldService, private route: ActivatedRoute, router: Router, authService: AuthService, uiStateService: UIStateService) {
        super(router, authService, MainpageComponent.route, uiStateService);
    }

    activate() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes[NpcComponent.inputPropertyName]) {
            if (this.npcDetails) {
                if (this.interactor) {
                    this.interactor.terminateCurrentInteraction();
                }
                this.subscriptions.push(this.worldService.retrieveNpcOptions(this.npcDetails.ExternalId).subscribe(interaction => {
                    this.activated.set(true);
                    this.interactor.beginInteraction(interaction, this.npcDetails.Name);
                }));
            }
        }
    }

}
